module.exports = __webpack_public_path__ + "img/6.0b71e6ce.png";